// axios 默认配置
export const AXIOS_DEFAULT_CONFIG = {
  withCredentials: true,
  timeout: 30000,
  // baseURL: 'http://easygotest.vanrui.com:18099/'
  // baseURL: 'http://api-easygo-stg.vanrui.com/web/portal/' // 测试环境
  // baseURL: window.ENV.baseURL
  // baseURL: 'http://10.39.176.57:8001/web/portal/'
  baseURL: '/web/portal/' // 开发环境登录使用，开发环境登录时要用或者接口，登录完换成下面的
  // baseURL: 'https://api-easygo-stg.vanrui.com/web/portal/' // 开发环境
  // baseURL: 'http://10.1.250.239:8091/'
  // 江才
  // baseURL: 'http://10.1.250.36:8099/'
  // 尚奔科
  // baseURL: 'http://40.73.68.142:8099/'
  // 杨柳
  // baseURL: 'http://10.1.250.147:8099'
  // baseURL: 'http://easygo.vanrui.com:8099'
  // 华明
  // baseURL: 'http://10.1.250.145:8099/'
}

export const AXIOS_SECOND_CONFIG = {
  // baseURL: 'http://112.74.178.87:8085/'
  baseURL: window.ENV.secondURL
}
// 访客定位睿联的页面
export const AXIOS_LOCATION_CONFIG = {
  // baseURL: 'http://39.108.89.82:9999/#/'
  baseURL: window.ENV.locationURL
}
// 睿讯API地址
export const AXIOS_RUIXUN_CONFIG = {
  // baseURL: 'http://stg-uclink.vanrui.com:8085/api/'
  baseURL: window.ENV.ruixunURL
}
// 路由默认配置，路由表并不从此注入
export const ROUTER_DEFAULT_CONFIG = {}



// WEBPACK FOOTER //
// ./src/config/config.js